<template>
  <div class="p-slider">
    <div class="p-slider__container">
      <img 
        v-for="(image, i) in images" 
        :src="image.image.url" 
        alt="" 
        class="p-slider__image u-cover" 
        ref="visual" 
        :aria-hidden="slideIndex !== i ? 'true' : 'false'">
    </div>
    <ul v-if="hasPager" class="p-slider__pager">
      <li v-for="(image, i) in images">
        <div>
          <transition name="scale">
            <span v-show="slideIndex === i && isRunning" class="p-slider__bar"></span>
          </transition>
        </div>
      </li>
    </ul>
  </div>
</template>

<style scoped>
  .scale-enter {
    transform: scaleX(0);
  }

  .scale-enter-active {
    transform-origin: 0 50%;
    transition: transform 7s cubic-bezier(0.550, 0.085, 0.680, 0.530); /* easeInQuad */
  }

  .scale-enter-to {
    transform: scaleX(1);
  }

  .scale-leave-active {
    transform-origin: 100% 50%;
    transition: 
      transform 1s cubic-bezier(0.895, 0.030, 0.685, 0.220); /* easeInQuart */;
  }

  .scale-leave-to {
    transform: scaleX(0);
    /*opacity: 0;*/
  }
</style>

<script>
  /**
   * Modules
   */
  import { mapGetters, mapActions } from 'vuex'
  import { setInterval, clearInterval } from 'requestanimationframe-timer'

  /**
   * Share Partial
   */

  const interval = 7000

  export default {
    name: 'slider',
    data() {
      return {
        timer: null,
        slideIndex: 0,
        isRunning: false,
      }
    },
    props: {
      images: {
        type: Array,
        required: true
      },
      hasPager: {
        type: Boolean,
        default: false
      }
    },
    mounted() {
    },
    beforeDestroy() {
      clearInterval(this.timer)
      this.timer = null
      this.slideIndex = 0
      this.isRunning = false
    },
    methods: {
      start() {
        if(this.images.length <= 1) {
          return
        }

        this.isRunning = true

        this.scale(this.slideIndex)

        this.timer = setInterval(() => {
          ++this.slideIndex

          if(this.slideIndex > this.images.length - 1) {
            this.slideIndex = 0            
          }

          this.scale(this.slideIndex)
        }, interval)
      },
      scale(index) {
        let image = this.$refs.visual[index]
        image.classList.add('is-animated')

        let timer = setInterval(() => {
          image.classList.remove('is-animated')
          clearInterval(timer)
          timer = null
          image = null
        }, 9000)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/partial/cominca-slider.vue